import script from "./title.vue?vue&type=script&setup=true&lang=js"
export * from "./title.vue?vue&type=script&setup=true&lang=js"

import "./title.vue?vue&type=style&index=0&id=7033810e&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7033810e"]])

export default __exports__